import { useTranslation } from "react-i18next";
import {
  ContentHeader,
  DesignTokens,
  MainContentArea,
  Text,
  ValueOrFallback,
} from "melco-ui";
import styled from "styled-components";
import { useBreadcrumb } from "../../hooks/navigation/useBreadcrumb";
import { JoinBetaTestingButton } from "../../components/reporting/proReporting/JoinBetaTestingButton";
import ImageCarousel from "../../components/imagecarousel/ImageCarousel";

import embroideryBravo from "../../images/embroidery-bravo.jpg";
import embroideryEmt16xNewCart from "../../images/embroidery-emt16x-newcart.jpg";
import submitObererBereich from "../../images/submit-oberer-bereich.png";

export const ProReporting: React.FC = () => {
  const { t } = useTranslation();

  const { spacings } = DesignTokens;
  const breadcrumb = useBreadcrumb("reporting");

  const ContentWrapper = styled.div`
    padding: 10px;
  `;

  const TextWrapper = styled.div`
    padding-right: ${spacings.xlarge}px;
    padding-top: ${spacings.xlarge}px;
    min-height: 90px;
    display: flex;
    align-items: left;
    justify-content: center;
    margin-bottom: 10px;
  `;

  return (
    <MainContentArea
      header={
        <ContentHeader
          title={
            <ValueOrFallback
              value={t("reporting.proreporting.title")}
              fallback={t("global.fallback.empty")}
            />
          }
          breadcrumb={breadcrumb}
          extra={<></>}
        />
      }
      contentPadding
    >
      {
        <>
          <ImageCarousel
            items={[
              {
                imgSrc: embroideryBravo,
                text: "With 16 needles, up to 1000 stitches per minute, and a 0 down, 0 percent financing starter bundle, the BRAVO is perfectly equipped to help you start making money in commercial embroidery.",
              },
              {
                imgSrc: embroideryEmt16xNewCart,
                text: "With up to 1500 stitches per minute and modular expandability, the EMT16X is the true gold standard in commercial embroidery technology.",
              },
              {
                imgSrc: submitObererBereich,
                text: "The Melco Summit revolutionizes the way you work with intelligent functions and an optimized workflow.",
              },
            ]}
            slidesToShow={3}
            key="pro-reporting-image-carousel"
          />
          <ContentWrapper>
            <Text>{t("reporting.proreporting.text.line1")}</Text>
            <TextWrapper>{t("reporting.proreporting.text.line2")}</TextWrapper>
            <JoinBetaTestingButton />
          </ContentWrapper>
        </>
      }
    </MainContentArea>
  );
};
